document.addEventListener('DOMContentLoaded', () => {
    const wishlistContainer = document.getElementById('wishlist-container');
    const emptyMessageContainer = document.getElementById('empty-wishlist-message');
    let wishlist = JSON.parse(localStorage.getItem('shopify-wishlist')) || [];

    // Function: Sabhi wishlist buttons ka style update karne ke liye
    function updateAllButtonsUI() {
        const allWishlistButtons = document.querySelectorAll('.wishlist-btn');
        allWishlistButtons.forEach(button => {
            const productHandle = button.dataset.productHandle;
            if (wishlist.includes(productHandle)) {
                button.classList.add('added');
            } else {
                button.classList.remove('added');
            }
        });
    }

    // Function: Wishlist mein product add ya remove karne ke liye
    function toggleWishlist(productHandle) {
        const index = wishlist.indexOf(productHandle);
        if (index > -1) {
            wishlist.splice(index, 1); // Wishlist se remove karein
        } else {
            wishlist.push(productHandle); // Wishlist mein add karein
        }
        localStorage.setItem('shopify-wishlist', JSON.stringify(wishlist));
        
        updateAllButtonsUI();
        displayWishlist();
    }

    // <<< --- SOLUTION: EVENT DELEGATION --- >>>
    // Poore page par click ke liye sirf ek event listener
    document.body.addEventListener('click', function(event) {
        // Check karein ki click .wishlist-btn par (ya uske andar) hua hai ya nahi
        const button = event.target.closest('.wishlist-btn');
        if (button) {
            event.preventDefault(); // Default button action ko rokein
            const handle = button.dataset.productHandle;
            if (handle) {
                // Sahi product handle ke saath function call karein
                toggleWishlist(handle);
            }
        }
    });

    // Function: Wishlist page par products ko display karne ke liye
    function displayWishlist() {
        // Agar wishlist container page par nahi hai to kuch na karein
        if (!wishlistContainer) {
            return;
        }
        if (wishlist.length > 0) {
            wishlistContainer.style.display = 'grid'; // Grid container ko dikhayein
            if (emptyMessageContainer) emptyMessageContainer.style.display = 'none';
            // Sabhi products ko ek saath fetch karein
            const fetchPromises = wishlist.map(handle => {
                return fetch(`${window.Shopify.routes.root}products/${handle}.js`)
                    .then(response => {
                        if (!response.ok) return null; // Agar product delete ho gaya ho
                        return response.json();
                    })
                    .catch(() => null); // Network error ke liye
            });
            // Jab saare products fetch ho jaayein...
            Promise.all(fetchPromises).then(products => {
                let productCardsHTML = '';
                products.forEach(product => {
                    if (product) { // Sirf un products ko display karein jo mile hain
                        // --- SOLUTION IS HERE ---
                        // Price ko format karne ke liye Intl.NumberFormat ka use karein
                        // NOTE: Agar aapki currency USD nahi hai, to 'USD' ko 'INR', 'EUR', 'CAD' etc. se badal dein.
                        const formattedPrice = new Intl.NumberFormat('en-US', { 
                            style: 'currency', 
                            currency: 'USD' 
                        }).format(product.price / 100);
                        productCardsHTML += `
                            <div class="grid__item medium-up--one-third">
                                <div class="card-wrapper">
                                    <div class="card">
                                        <a href="${product.url}" class="card__link">
                                            <div class="card__image-wrapper">
                                                <img class="block" src="${product.featured_image}" alt="${product.title}">
                                            </div>
                                            <div class="card__info">
                                                <div class="card__heading">${product.title}</div>
                                                <div class="card-price font_14px">
                                                    ${formattedPrice}
                                                </div>
                                            </div>
                                        </a>
                                        <button class="wishlist-btn added" data-product-handle="${product.handle}" aria-label="Remove from Wishlist">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="block" width="clamp(18px, 1.6vw, 24px)" height="clamp(18px, 1.6vw, 24px)" viewBox="0 0 24 24" fill="black" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        `;
                    }
                });
                wishlistContainer.innerHTML = productCardsHTML;
            });
        } else {
            wishlistContainer.style.display = 'none';
            if (emptyMessageContainer) emptyMessageContainer.style.display = 'block';
        }
    }
    updateAllButtonsUI();
    displayWishlist();
});